import { useQuery, useQueryClient } from "@tanstack/react-query";
import IArborApplication from "../models/ArborApplication";
import { ServiceManager } from "../services/ServiceManager";

export const arborApplicationsQueryKey = ["arbor-applications"] as const;

export function useArborApplications(enabled: boolean = true) {
    return useQuery<IArborApplication[]>({
        queryKey: arborApplicationsQueryKey,
        queryFn: () => ServiceManager.ArborApplicationService.GetApplications(),
        enabled
    });
}

export function useInvalidateArborApplications(): () => Promise<void> {
    const queryClient = useQueryClient();

    return () => queryClient.invalidateQueries({ queryKey: arborApplicationsQueryKey });
}